// 查询表单配置
let formConfig = [
  { label: '油站', type: 'select', modelName: 'gasId', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'gasName', selectValue: 'gasId' },
  { label: '订单号', type: 'input', modelName: 'orderCode', placeholder: '', maxlength: 100 },
  { label: '支付时间', type: 'date', modelName: 'tradeTime', model: '', dateType: 'datetimerange', format: 'yyyy-MM-dd HH:mm:ss',pickerOptions:{}, clearable:false },
  { label: '账单类型', type: 'select', modelName: 'orderType', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'label', selectValue: 'value' }
]
// 表格参数配置
let tableConfig = [
  { label: '非油品订单号', prop: 'orderNo', width: 190 },
  { label: '油站名称', prop: 'gasName', width: 200 },
  { label: '订单金额(元)', prop: 'orderAmount', width: 136 },
  { label: '应结算金额(元)', prop: 'shouldSettlementAmount', width: 136 },
  { label: '实际结算金额(元)', prop: 'realSettlementAmount', width: 136 },
  { label: '商品名称', prop: 'goodsName', width: 136 },
  { label: '商品数量', prop: 'goodsNum', width: 136 },
  { label: '商品价格', prop: 'goodsPrice', width: 136},
  { label: '账单类型', prop: 'tradeType',width: 136 },
  { label: '账单状态', prop: 'billTypeDesc',width: 136 },
]

let sumLabel = {
  totalAmount:'订单总金额(元)',
  totalNum:'订单数(笔)',
  totalShouldAmount:'应结算金额(元)',
  totalSettlementAmount:'实际结算金额(元)'
}
let sumInfo = {
  totalAmount: '0.00',
  totalNum: '0.00',
  totalShouldAmount: '0.00',
  totalSettlementAmount: '0.00'
}
let tipsInfo = {
  totalAmount: '订单原价汇总',
  totalNum: '订单的笔数汇总',
  totalShouldAmount: '订单中油站分成金额',
  totalSettlementAmount: '实际结算金额=应结算金额-优惠金额'
}

export default {
  formConfig,
  tableConfig,
  sumLabel,
  sumInfo,
  tipsInfo
}